import PropTypes from 'prop-types';
import React from 'react';

import Button from 'gd-comp-button';

const props = {
    name: PropTypes.string,
    message: PropTypes.object,
    comment: PropTypes.string,

    yesBtnLabel: PropTypes.string,
    noBtnLabel: PropTypes.string,

    onYesCallback: PropTypes.func.isRequired,
    onNoCallback: PropTypes.func // not sure if we use it
};

const defaultProps = {
    yesBtnLabel: "Yes, delete",
    noBtnLabel: "No, cancel"
};

class ModalConfirmDelete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            yesClicked: false   // use to show "busy" state
        };

    }

    onYesClick = (e) => {
        e.stopPropagation();

        this.setState({yesClicked:true});
        this.props.onYesCallback();
    }

    onNoClick = (e) => {
        e.stopPropagation();

        gd.modal.hide();
        if (this.props.onNoCallback) this.props.onNoCallback();
    }

    renderYesNo() {

        const yesBtnType = this.state.yesClicked ? 'busy' : 'blue';
        return (
            <div className="actions">
                <Button label={this.props.yesBtnLabel} type={yesBtnType} onClick={this.onYesClick} />
                <Button label={this.props.noBtnLabel} type="normal" onClick={this.onNoClick} />
            </div>
        );
    }

    render() {

        let message = this.props.message;

        if (!message) {

            if (this.props.name) {
                message = (
                    <div className="message">
                        <div className="txt">Are you sure that you want to delete</div><div className="highlight">{this.props.name}</div> <div className="txt">?</div>
                    </div>
                )
            } else {
                message = (
                    <div className="message">
                        <div className="txt">Are you sure that you want to delete it ?</div>
                    </div>
                )
            }


        }

        return (
            <div className="">
                {message}
                {!!this.props.comment && <div className="comment">{this.props.comment}</div>}
                {this.renderYesNo()}
            </div>
        );
    }

}

ModalConfirmDelete.propTypes = props;
ModalConfirmDelete.defaultProps = defaultProps;

module.exports = ModalConfirmDelete;
